<template>
  <li
    class="p-3 d-flex justify-content-between align-content-center"
  >
    <p class="mb-0 align-text-center">
      {{ email }}
    </p>
    <div>
      <span
        class="link"
        @click="resend"
        v-if="resendEnabled && !isLinkActivated"
      >
        Resend
      </span>
      <span
        class="link-activated"
        v-if="resendEnabled && isLinkActivated"
      >
        Link Resent
      </span>
      <button
        id="share-modal-email-delete"
        @click="showDeleteConfirmation()"
        data-test="creative-share-delete-btn"
        ref="share-email-input"
        class="ml-4"
      >
        <i class="fa-light fa-trash-alt" />
      </button>
    </div>
    <b-modal
      :id="`deleteEmailConfirmationModal${index}`"
      size="sm"
      centered
      title="Are you sure?"
      @ok="deleteEmail()"
    >
      <p
        class="my-1"
        style="word-break: break-word;"
      >
        Are you sure you want to remove<br>
        {{ email }}
      </p>
      <template
        #modal-footer="{ cancel, ok }"
      >
        <b-button
          size="md"
          variant="tertiary"
          @click="cancel()"
        >
          Cancel
        </b-button>
        <b-button
          size="md"
          variant="primary"
          @click="ok()"
        >
          OK
        </b-button>
      </template>
    </b-modal>
  </li>
</template>
<script>

import { mapActions, mapMutations } from 'vuex';
import * as shareTypes from '@/modules/share/store/types';
import * as accountTypes from '@/modules/account/store/types';
import * as types from '@/store/types';

export default {
  name: 'ShareModalEmailsListItem',
  props: {
    index: {
      type: Number,
      default: 0,
    },
    resendEnabled: {
      type: Boolean,
      default: false,
    },
    shareType: {
      type: String,
      default: '',
    },
    campaign: {
      type: Object,
      default: null,
    },
    creative: {
      type: Object,
      default: null,
    },
    email: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isLinkActivated: false,
    };
  },
  methods: {
    ...mapActions('share', [
      shareTypes.RESEND_SHARE_WITH_EMAIL,
    ]),
    ...mapActions('account', [
      accountTypes.GET_USER_EMAIL_EXIST,
    ]),
    ...mapMutations([
      types.SET_GLOBAL_MESSAGE,
    ]),
    showDeleteConfirmation() {
      this.$root.$emit('bv::show::modal', `deleteEmailConfirmationModal${this.index}`, '#share-email-input');
    },
    deleteEmail() {
      this.$emit('removeEmail', this.email);
    },
    resendToEmail() {
      return this.RESEND_SHARE_WITH_EMAIL({
        campaignId: this.campaign.id,
        body: {
          type: this.shareType,
          sharedWithEmails: [this.email],
        },
      });
    },
    async resend() {
      await this.resendToEmail();
      this.SET_GLOBAL_MESSAGE({
        message: 'Resent successfully',
        type: 'success',
      });
      this.isLinkActivated = true;
      setTimeout(() => {
        this.isLinkActivated = false;
      }, 30000);
    },
  },
};
</script>
<style lang="scss" scoped>
#share-modal-email-delete {
  border: none;
  background-color: transparent;
}
.fa-trash-alt {
  font-size: 18px;
}
.link {
   color: #007BFF;
   cursor: pointer;
 }
.link:hover {
  color: #0056b3;
  text-decoration: underline;
}
.link-activated {
  color: #B0B6BA;
}
</style>
